function setToStorage(classifiedId, key) {
    if (!localStorage) {
        console.warn("LocalStorage is not available.");
        return;
    }
    const seen = localStorage.getItem(key);
    let storageValue = {};
    if (seen) {
        storageValue = JSON.parse(seen);
        storageValue[classifiedId] = new Date().getTime();
    }
    else {
        storageValue[classifiedId] = new Date().getTime();
    }
    try {
        localStorage.setItem(key, JSON.stringify(storageValue));
    }
    catch (error) {
        console.error(`Failed to save to storage with key "${key}":`, error);
    }
}
export function saveContactToStorage(classifiedId) {
    setToStorage(classifiedId, "aviv_cdp_contact");
}
export function saveSeenToStorage(classifiedId) {
    setToStorage(classifiedId, "aviv_cdp_seen");
}
